
import React from 'react';

interface FunctionalityCardProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  index: number;
}

const FunctionalityCard: React.FC<FunctionalityCardProps> = ({ icon, title, description }) => {
  return (
    <div className="group h-full bg-white rounded-xl p-4 shadow-sm hover:shadow-lg hover:-translate-y-1 hover:scale-[1.02] transition-all duration-300">
      <div className="flex flex-col items-center text-center space-y-2">
        <div className="w-12 h-12 rounded-lg bg-orcsys-50 flex items-center justify-center mb-2 group-hover:bg-orcsys-100 transition-colors duration-300">
          {icon}
        </div>
        <h3 className="font-semibold text-slate-900 group-hover:text-orcsys-500 transition-colors duration-300">
          {title}
        </h3>
        <p className="text-sm text-slate-600 leading-snug">
          {description}
        </p>
      </div>
    </div>
  );
};

export default FunctionalityCard;
